import React, { useMemo, useState } from "react";
import { Button, Form } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { orderedVisitTypesForProvider } from "../../utils/bookingFlowUtil";

export default function StepService({
  formData,
  setFormData,
  onNext,
  onBack,
  facilityData,
  providerConfig,
}) {
  const [selected, setSelected] = useState(formData.service?.visit_type_id || null);

  const list = useMemo(() => {
    const raw = facilityData?.data?.[formData.category] || [];
    const mid = formData?.selectedProvider?.member_id;
    const provider = (providerConfig?.providers || []).find(
      (p) => String(p.member_id) === String(mid)
    );
    if (provider && raw.length) {
      const ordered = orderedVisitTypesForProvider(
        facilityData.data,
        provider,
        formData.category
      );
      if (ordered.length) return ordered;
    }
    return raw;
  }, [facilityData, formData.category, formData.selectedProvider, providerConfig]);

  const handleSelect = (srv) => {
    setSelected(srv.visit_type_id);
    setFormData({ ...formData, service: srv });
  };

  return (
    <div className="step-service">
      <h2 className="form-title text-white">Select a Service</h2>

      <div className="service-grid">
        {list.map((srv) => (
          <div
            key={srv.visit_type_id}
            onClick={() => handleSelect(srv)}
            className={`service-card ${selected === srv.visit_type_id ? "selected" : ""}`}
          >
            {selected === srv.visit_type_id && (
              <CheckCircleTwoTone twoToneColor="#fc8c02" className="check-icon" />
            )}
            <h3 className="service-name">{srv.visit_type}</h3>
            <p className="service-desc">Duration: {srv.duration} minutes</p>
            <p className="service-desc">Mode: {srv.appointment_mode}</p>
            {srv?.visit_type_charge && <p className="service-price">
              Price: ${srv.visit_type_charge}
            </p>}
            {/* <p className="service-price">
              Color: <span style={{ color: srv.visit_type_color.split(":")[0] }}>■</span>
            </p> */}
          </div>
        ))}
      </div>

    

          <Form.Item style={{width:'100%' }}>
  <div style={{ display: "flex", gap: "1rem"}}>
    <Button className="btn-css-class" onClick={onBack} block>
      Back
    </Button>
     <Button
        type="primary"
        size="large"
        block
        disabled={!selected}
        onClick={onNext}
        className="btn-css"
      >
        Continue
      </Button>
  </div>
</Form.Item>
      
    </div>
  );
}
